import { useMediaQuery, useTheme } from '@mui/material';
import { useMemo } from 'react';

const useNavigationMode = () => {
    const theme = useTheme();
    const matchMd = useMediaQuery(theme.breakpoints.up('md'));

    return useMemo(() => (matchMd ? 'header' : 'sidebar'), [matchMd]);
};

export default useNavigationMode;
